<script lang="ts">
	import HeroSlider from '$lib/components/HeroSlider.svelte';
	import HeroSlide from '$lib/components/HeroSlide.svelte';
	import CenteredWithImageSection from '$lib/components/CenteredWithImageSection.svelte';
	import ServiceBox from '$lib/components/ServiceBox.svelte';
	import SupplierBox from '$lib/components/SupplierBox.svelte';
	import { SITE_DISPLAY_NAME } from '$lib/constants';
	import TallyContact from '$lib/components/TallyContact.svelte';
</script>

<svelte:head>
	<title>{SITE_DISPLAY_NAME}</title>
</svelte:head>

<HeroSlider>
	<HeroSlide
		title="Genesis"
		subtitle="Outdoor Living"
		tagline="Experience Raleigh and Cary's Award Winning Service Today"
		backgroundImage="/assets/images/background/home_ss_1174898596.webp"
	/>
</HeroSlider>

<CenteredWithImageSection style="dark" image="/assets/images/background/awards_ss_272220959.webp">
	<h1 class="mb-0 font-700 text-uppercase mt-0">About Us</h1>
	<h2 class="mt-10 font-200 letter-spacing-10 source-font text-uppercase">Quality</h2>
	<div class="mt-30 lead">
		<p>
			We provide high quality landscaping services in Cary, Apex, Raleigh, Morrisville, Holly
			Springs, and Fuquay-Varina.
		</p>
		<p>
			We are passionate about what we do and work tirelessly to bring your vision to life. We aren't
			happy unless you are.
		</p>
		<p>We are Genesis.</p>
	</div>
</CenteredWithImageSection>

<section class="white-bg">
	<div class="container">
		<div class="row">
			<div class="col-sm-12 text-center">
				<h1 class="mb-0 mt-0 font-700 text-uppercase">Our Services</h1>
			</div>
		</div>
		<div class="row mt-50">
			<div class="col-md-4 col-sm-6">
				<ServiceBox
					image="/assets/images/background/lawncare_ss_1384150394.webp"
					title="Lawn Care"
					description="We offer a wide variety of lawn care services and options to ensure your yard stays in top shape year round!"
					link="/services/lawncare"
				/>
			</div>
			<div class="col-md-4 col-sm-6">
				<ServiceBox
					image="/assets/images/background/seasonal_maintenance_us_Gu7D9ocA.webp"
					imagePosition="bottom"
					title="Seasonal Maintenance"
					description="À la carte - Build your personalized maintenance packge."
					link="/services/maintenance"
				/>
			</div>
			<div class="col-md-4 col-sm-6">
				<ServiceBox
					image="/assets/images/background/hardscape_ss_719379451.webp"
					title="Hardscape"
					description="We have over 20 years of experience on our team in the installation of a variety of hardscape projects."
					link="/services/hardscape"
				/>
			</div>
			<div class="col-md-4 col-sm-6">
				<ServiceBox
					image="/assets/images/background/drainage_grading_ss_1286490334.webp"
					title="Drainage & Grading"
					description="We offer a range of drainage and grading options to make sure your property stays in great condition!"
					link="/services/drainage-grading"
				/>
			</div>
			<div class="col-md-4 col-sm-6">
				<ServiceBox
					image="/assets/images/background/design_ss_366207515.webp"
					title="Design"
					description="We can help you transform your property and bring your vision to life!"
					link="/services/design"
				/>
			</div>
		</div>
	</div>
</section>

<section class="dark-bg">
	<div class="container">
		<div class="row">
			<div class="col-sm-12 text-center">
				<h1 class="mb-0 mt-0 font-700 text-uppercase white-color">Our Suppliers</h1>
			</div>
		</div>
		<div class="row mt-50">
			<div class="col-sm-4 mb-10">
				<SupplierBox
					image="/assets/images/suppliers/PittsboroLandscapeSupply.webp"
					title="Pittsboro Landscape Supply"
					link="https://www.pittsborolandscapesupply.com/"
					alt="Logo for Pittsboro Landscape Supply"
				/>
			</div>
			<div class="col-sm-4 mb-10">
				<SupplierBox
					image="/assets/images/suppliers/CarpenterFarmSupplyCo.webp"
					title="Carpenter Farm Supply Co"
					link="http://www.carpenterfarmsupplyco.com/"
					alt="Logo for Carpenter Farm Supply Co"
				/>
			</div>
			<div class="col-sm-4">
				<SupplierBox
					image="/assets/images/suppliers/SiteOne.webp"
					title="SiteOne Landscape Supply"
					link="https://www.siteone.com/"
					alt="Logo for SiteOne Landscape Supply"
				/>
			</div>
		</div>
	</div>
</section>

<!-- <ContactForm style="dark"  /> -->
<TallyContact image="/assets/images/background/contact_us_BAanEbxe9No.webp" />
